import * as types from "./actionTypes"

export function fetchSwitchInstructionPatterns() {
    return {
        type: types.FETCH_SWITCH_INSTRUCTION_PATTERNS,
    }
}

export function setSwitchInstructionPatterns(data) {
    return {
        type: types.SET_SWITCH_INSTRUCTION_PATTERNS,
        payload: data,
    }
}

export function fetchSwitchInstructionPatternsFailed(error) {
    return {
        type: types.FETCH_SWITCH_INSTRUCTION_PATTERNS_FAILED,
        payload: error,
    }
}
export function createSwitchInstruction(details = {}) {
    return {
        type: types.CREATE_SWITCH_INSTRUCTION,
        payload: details,
    }
}
export function createSwitchInstructionSuccess(response = {}) {
    return {
        type: types.CREATE_SWITCH_INSTRUCTION_SUCCESS,
        payload: response,
    }
}
export function createSwitchInstructionFailue(error = {}) {
    return {
        type: types.CREATE_SWITCH_INSTRUCTION_FAILURE,
        payload: error,
    }
}

export function fetchSwitchRequests(data) {
    return {
        type: types.SWITCH_REQUESTS_FETCH_DATA,
        payload: data,
    }
}

export function fetchSwitchRequestsFilter(data) {
    return {
        type: types.SWITCH_REQUESTS_FETCH_FILTER,
        payload: data,
    }
}

export function fetchSwitchRequestsSuccess(data) {
    return {
        type: types.SWITCH_REQUESTS_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchSwitchRequestsFailure() {
    return {
        type: types.SWITCH_REQUESTS_DATA_FAILURE,
    }
}
